<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    size="xs"
    :quasar-props="{ maximized: false }"
    :header="{
      title: $t('ETAB.PAGES.DEMANDS.CREATION.@CLOTHING_COLOR_MODAL_TITLE'),
    }"
    :card="{ class: 'creation-color-modal' }"
  >
    <template #body>
      <QList>
        <QItem v-for="color in colors" :key="color.getCode()" clickable @click="$emit('selectColor', color)">
          <QItemSection avatar>
            <span class="clothing-color" :style="{ background: color.getCode() }" />
          </QItemSection>

          <QItemSection>{{ $t(color.getLabel()) }}</QItemSection>
        </QItem>
      </QList>
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      colors: {
        type: Array,
        default: () => [],
      },
    },
    emits: ["update:opened", "selectColor"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
    },
  };
</script>

<style lang="scss">
  .creation-color-modal {
    .clothing-color {
      display: block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      box-shadow: $btn-shadow;
    }
  }
</style>
